import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetCardSeriesModel } from "@factory/model/query-model-card-series";
import { cardSeriesFormDefault } from "./form.default";
import { CardSeriesFormSchema } from "./form.rule";

export const useFormDefaultCardSeries = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetCardSeriesModel | undefined) => {
    return !cachedValue
      ? cardSeriesFormDefault
      : ({
          tenant: cachedValue.tenant,
          cardCategory: cachedValue.card_category,
        } as CardSeriesFormSchema);
  };

  return {
    getDefault,
  };
};
